export default __webpack_public_path__ + "static/media/il_avatar.5a34a241.svg";